// src/pages/purchaseOrder/components/FinancialDetailsSection.jsx
import React from 'react';
import { DollarSign } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import { formatCurrency } from '../../../utils/currencyUtil';
import styles from './FinancialDetailsSection.module.css';

const FinancialDetailsSection = ({ formData, totals, errors, onFieldChange, disabled = false, currency = null, beforeGrandTotal = null }) => {
  const { t } = useLocalization();

  return (
    <div className={styles.financialContent}>
      <div className={styles.summarySection}>
        <div className={styles.summaryRow}>
          <span>{t('purchaseOrder.subtotal')}:</span>
          <span className={styles.summaryValue}>{formatCurrency(totals.subtotal, currency)}</span>
        </div>
      </div>

      <div className={styles.formGroup}>
        <label>{t('purchaseOrder.extraCharges')}</label>
        <div className={styles.inputWrapper}>
          <DollarSign className={styles.inputIcon} size={16} />
          <input
            type="number"
            value={formData.extraCharges}
            onChange={(e) => onFieldChange('extraCharges', e.target.value)}
            placeholder={t('purchaseOrder.extraChargesPlaceholder')}
            min="0"
            step="0.01"
            className={errors.extraCharges ? styles.error : ''}
            disabled={disabled}
          />
        </div>
        {errors.extraCharges && <span className={styles.errorText}>{errors.extraCharges}</span>}
        <textarea
          value={formData.extraChargesDescription}
          onChange={(e) => onFieldChange('extraChargesDescription', e.target.value)}
          placeholder={t('purchaseOrder.extraChargesDescriptionPlaceholder')}
          rows={2}
          className={styles.descriptionInput}
          disabled={disabled}
        />
      </div>

      <div className={styles.formGroup}>
        <label>{t('purchaseOrder.discountAmount')}</label>
        <div className={styles.inputWrapper}>
          <DollarSign className={styles.inputIcon} size={16} />
          <input
            type="number"
            value={formData.discountAmount}
            onChange={(e) => onFieldChange('discountAmount', e.target.value)}
            placeholder={t('purchaseOrder.discountAmountPlaceholder')}
            min="0"
            step="0.01"
            className={errors.discountAmount ? styles.error : ''}
            disabled={disabled}
          />
        </div>
        {errors.discountAmount && <span className={styles.errorText}>{errors.discountAmount}</span>}
        <textarea
          value={formData.discountDescription}
          onChange={(e) => onFieldChange('discountDescription', e.target.value)}
          placeholder={t('purchaseOrder.discountDescriptionPlaceholder')}
          rows={2}
          className={styles.descriptionInput}
          disabled={disabled}
        />
      </div>

      {beforeGrandTotal}

      <div className={styles.grandTotal}>
        <span>{t('purchaseOrder.grandTotal')}:</span>
        <span className={styles.grandTotalValue}>{formatCurrency(totals.grandTotal, currency)}</span>
      </div>
    </div>
  );
};

export default FinancialDetailsSection;